import { Project } from 'shared/hooks/use_project/types'

export class MatchingFundHelper {
  static locallyActiveMatchingFund(project: Project) {
    if (project && project.active_matching_fund && !project.active_matching_fund.client_id) {
      return project.active_matching_fund
    }
  }
}
